import MessageBox from "sap/m/MessageBox";
import {
  AudioConfig,
  IPlayer,
  SpeakerAudioDestination,
  SpeechConfig,
  SpeechRecognizer,
  SpeechSynthesizer,
} from "../libs/microsoft.cognitive.speech.sdk/microsoft.cognitiveservices.speech.sdk.bundle";
import AzureTokenService from "./AzureToken.service";

export default class SpeechService {
  private _azureTokenService: AzureTokenService;
  private _player: SpeakerAudioDestination;

  constructor() {
    this._azureTokenService = new AzureTokenService();
  }

  public getAudioContext(): AudioContext {
    let context: AudioContext;

    const AudioContext =
      window.AudioContext || // prefered impl
      ((<any>window).webkitAudioContext as {
        prototype: AudioContext;
        new (contextOptions?: AudioContextOptions): AudioContext;
      }) || // fallback, mostly when on Safari
      false; // could not find

    if (AudioContext) {
      context = new AudioContext();
    } else {
      MessageBox.warning("Spracherkennung wird nicht unterstützt.");
    }

    return context;
  }

  private getAudioConfig(): AudioConfig {
    return window.SpeechSDK.AudioConfig.fromDefaultMicrophoneInput() as AudioConfig;
  }

  private getSpeechConfig(token: string, region: string): SpeechConfig {
    return window.SpeechSDK.SpeechConfig.fromAuthorizationToken(token, region) as SpeechConfig;
  }

  public getSpeechRecognizer = async (): Promise<SpeechRecognizer> => {
    const token = await this._azureTokenService.getAuthorizationToken();
    const audioConfig = this.getAudioConfig();
    const speechConfig = this.getSpeechConfig(token.token, token.region);
    speechConfig.speechRecognitionLanguage = "de-DE";
    return new window.SpeechSDK.SpeechRecognizer(speechConfig, audioConfig) as SpeechRecognizer;
  };

  public getSpeechSynthesizer = async (): Promise<SpeechSynthesizer> => {
    const token = await this._azureTokenService.getAuthorizationToken();

    let audioStream = window.SpeechSDK.PullAudioOutputStream.create();
    const audioConfig = window.SpeechSDK.AudioConfig.fromStreamOutput(audioStream);
    const speechConfig = this.getSpeechConfig(token.token, token.region);

    speechConfig.speechSynthesisLanguage = "de-DE";
    speechConfig.speechSynthesisVoiceName = "de-DE-SeraphinaMultilingualNeural";
    return new window.SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig) as SpeechSynthesizer;
  };
}
